import { useQuery } from '@src/shared/query';
import type { GroupStat, GroupStatDto } from '../../types';
import { groupStatsUrl } from './constants';

function selectGroupStats(data: GroupStatDto[]): GroupStat[] {
  return data.map((dto) => ({
    groupId: dto.group_id,
    groupName: dto.group_name,
    groupCanonicalName: dto.group_canonical_name,
    colourFg: dto.colour_fg,
    colourBg: dto.colour_bg,
    used: dto.used,
    available: dto.available,
    warning: dto.warning,
    error: dto.error,
  }));
}

export default function useGroupStats(userId: number | null) {
  const { data: groupStats = [], ...restQuery } = useQuery<
    GroupStatDto[],
    GroupStat[]
  >(groupStatsUrl, {
    queryParams: userId ? { user_id: String(userId) } : {},
    select: selectGroupStats,
    enabled: !!userId,
  });

  return {
    groupStats,
    ...restQuery,
  };
}
